const launch = {
  path: 'launch',
  component: resolve => require(['@/pages/admin/reviewed/alipay/launch'], resolve),
  meta: {isLaunch: true}
}

export default launch
